<app-header></app-header>
<div class="container-fluid section">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 sub-section">
            <div class="row">
                <div class="col-12 col-md-4 px-0 left-section" [ngClass]="{'d-block': screen==1, 'd-none d-md-block': screen==2}">
                    <app-chat-list (selectedChat)="viewChat($event)"></app-chat-list>
                </div>
                <div class="col-12 col-md-8 px-0" [ngClass]="{'d-block': screen==2, 'd-none d-md-block': screen==1}">
                    <app-chat-messages (close)="closeChat($event)"></app-chat-messages>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>